import TurnDisplay from './TurnDisplay';

export default TurnDisplay;